<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Tooltip
    ref="tooltipRef"
    v-bind="$props"
    :text="String(getTextTooltip)"
    :disabled="disabled"
    :ui="{
      ...$props.ui,
      tooltip: [$props.ui?.tooltip, 'epk-tooltip__tooltip'],
    }"
    @close="$emit('close')"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
    <template
      v-if="$slots.content"
      #content
    >
      <slot name="content" />
    </template>
    <template
      v-if="$slots.footer"
      #footer
    >
      <slot name="footer" />
    </template>
  </Tooltip>
</template>

<script setup lang="ts">
import { computed, ref, useSlots, watch } from 'vue';

import { Tooltip, type TooltipProps } from '@mkskom/ui';

const slots = useSlots();

export interface ITooltipProps {
  hasButtonClose?: TooltipProps['hasButtonClose'];
  position?: TooltipProps['position'];
  text?: TooltipProps['text'] | number;
  type?: TooltipProps['type'];
  disabled?: TooltipProps['disabled'];
  delay?: TooltipProps['delay'];
  offset?: TooltipProps['offset'];
  ui?: TooltipProps['ui'];
}
const props = withDefaults(defineProps<ITooltipProps>(), {
  hasButtonClose: false,
  text: undefined,
  type: 'hint',
  disabled: false,
  delay: 1000,
  offset: () => [10, 10],
  position: 'bottom-left-aligned',
});

defineEmits<{ (e: 'close'): void }>();

const tooltipRef = ref<InstanceType<typeof Tooltip> | null>(null);

const getTextTooltip = computed(() => {
  if (props.text) return props.text;

  if (slots.default) {
    return slots
      .default()
      .map(node => {
        return typeof node.children === 'string' ? node.children : '';
      })
      .join('');
  }

  return '';
});

const closeTooltip = () => tooltipRef.value?.closeTooltip();

watch([() => props.disabled, () => props.text], (d, t) =>
  d || !t ? closeTooltip() : ''
);

defineExpose({ closeTooltip });
</script>

<style lang="scss">
@import './Tooltip';
</style>
